import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';



const Introduction = ({language}) => {
    return (
        <section className="letape-du-tour-introduction">
            <Container>
                <Row className='aling-items-center mt-5'>
                    <Col>
                        <h3 className='text-center'>{language === "Chinese"? "你是頂尖的自行車選手嗎？" : "Are you a top cyclist?"}</h3>
                        {language === "Chinese" ? <div>
                            <p className='text-center mt-5'>你是否曾想過贏得一場環法自行車賽系列比賽？ 本計畫專為想展現生涯最佳狀態的頂尖車手設計。</p>
                            <p className='text-center'>在日月潭站奪下103K挑戰組總冠軍，即可取得前往法國參加2027 L’Étape 錦標賽的資格。</p>
                            <p className='text-center mb-5'>你將從本站出發，與最具競爭力的車手一同比賽，還有機會可在比賽村享受獨特的 L’Étape 冠軍賽資格賽待遇。</p>
                        </div> : <div>
                                <p className="text-center mt-5">Have you ever dreamed of winning a L’Étape by Tour de France race? This program is designed for elite riders who want to deliver the best performance of their careers.</p>
                                <p className='text-center'>Win the 103K The Race overall at Sun Moon Lake and you earn a spot at the 2027 L’Étape Championship in France.</p>
                                <p className='text-center mb-5'>Starting from this event, you’ll race alongside the most competitive riders and can enjoy exclusive L’Étape Championship qualifier perks in the Race Village.</p>
                        </div>}
                        
                        <iframe width="1120" height="630" src="https://www.youtube.com/embed/TpuFMseiYkY?si=dI1lzZmvNpxzH_cX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </Col>
                </Row>
                <Row className='aling-items-center mt-5'>
                    <Col md={6}>
                        <h3 className='text-stroke text-center'>L’Étape REWARD</h3>
                        <p className='px-5 mt-5'>{language === "Chinese"? "參加世界各地的任一 L’Étape by Tour de France 賽事，您將獲得 L’Étape du Tour 法國站的獨家優先報名權。" : "Take part in any L’Étape by Tour de France event around the world and you will get exclusive priority registration for L’Étape du Tour in France."}</p>
                    </Col>
                    <Col md={6} className='bg-white text-black'>
                        <h3 className='text-stroke-reverse text-center'>L’Étape Championship</h3>
                        <p className='px-5 mt-5'>{language === "Chinese"? "日月潭站僅103K挑戰組總冠軍（前三名中僅冠軍享有席次，機票及住宿自理）與登山王冠軍，可獲得前往法國參加2027 L’Étape 錦標賽的資格。" : "At L’Étape Sun Moon Lake, only the 103K The Race overall champion (not the full top 3; flights and accommodation at own expense) and the King of the Mountains winners earn a spot at the 2027 L’Étape Championship in France."}</p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Introduction